import { get } from 'lodash/fp'
import { createSelector } from 'reselect'

export const isUseLegacyServiceForProduct = get('partner.useLegacyForProduct')

export const isUseLegacySubmission = get('partner.useLegacySubmission')

export const isRequesting = get('partner.requesting')

export const isFetchingCalculate = get('partner.fetching_calculate')

export const isFetchingPolicy = get('partner.fetching_policy')

/**
 * @return {typeof import('quick-quote/reducers').TriggerBy}
 */
export const getRequestTrigger = get('partner.trigger_by')

export const shouldDisableForm = createSelector(
  isRequesting,
  getRequestTrigger,
  (isRequesting, triggerBy) => isRequesting && ['toggle_rider', 'change_product'].includes(triggerBy)
)

export const isApiRequesting = isRequesting

export const getPartnerFormState = get('partner.form_state')

export const getPartnerPackageCanProcess = get('partner.canPackageProcess')

export const getPartnerCurrentSelectedProduct = get('partner.currentSelectedProduct')

export const getPartnerAvailableDisplayProduct = get('partner.availableDisplayProducts')

export const getPartnerAvailableDisplayProductByCode = (code) =>
  createSelector(getPartnerAvailableDisplayProduct, (availableDisplayProducts) => availableDisplayProducts[code])

export const getPartnerAvailableRiders = get('partner.availableRiders')

export const getPartnerAvailableRiderByDisplayProductCode = (code) =>
  createSelector(getPartnerAvailableRiders, (availableRiders) => availableRiders[code])

export const getPartnerKYCQuestion = get('partner.e_submission.kyc_question')

export const getSellerInfo = get('partner.seller_profile')
